const TEMPLATES_GAME = ['lite', 'retro', 'primary-2022', 'primary-2025', 'secondary-2022', 'secondary-pqlco'];
const TEMPLATES_KANBAN = ['lite', 'retro', 'primary-2022', 'primary-2025', 'secondary-2022', 'secondary-pqlco', 'steam'];

const TEMPLATE_COMPONENTS = 'components';
const TEMPLATE_COMPONENTS_PDFS = 'components_pdf';
const TEMPLATE_KIDS = 'tangerine-kids';
const TEMPLATE_NEW_PRIMARY = 'primary-2022';
const TEMPLATE_PRIMARY_2025 = 'primary-2025';
const TEMPLATE_STEAM = 'steam';
const TEMPLATE_UNOI = 'unoi';
const TEMPLATE_VANILLA = 'vanilla';

export const TEMPLATE_PRIMARY_FIXED = 'primary-fixed';
export const TEMPLATE_PRIMARY_HYBRID = 'primary-hybrid';
export const TEMPLATE_TOOLBOX_STANDALONE = 'toolbox-standalone';

export const TYPE_LESSON_VANILLA = ['teacher', 'mint'];
export const TYPE_LESSON_MINT_GAME = ['mint', 'game'];

export function isAccessSelectTrimester(data) {
  // Access: <SelectTrimester />
  return data.template.value === TEMPLATE_NEW_PRIMARY || data.template.value === TEMPLATE_PRIMARY_2025;
}

export function isAccessProgramFormResources(data) {
  // Access: <ProgramFormResources />
  return data.template.value === TEMPLATE_NEW_PRIMARY || data.template.value === TEMPLATE_PRIMARY_2025;
}

export function isVanillaTemplate(template) {
  const { value } = template;
  return value === undefined || value === TEMPLATE_VANILLA || isUnoiTemplate(template) || isKidTemplate(template);
}

export function isVanillaTemplateTab(template) {
  const { value } = template;
  return value === undefined || value === TEMPLATE_VANILLA;
}

export function isUnoiTemplate(template) {
  const { value } = template;
  return value === TEMPLATE_UNOI;
}

export function isKidTemplate(template) {
  const { value } = template;
  return value === TEMPLATE_KIDS;
}

export function isKanban(template) {
  const { value } = template;
  return TEMPLATES_KANBAN.find((item) => item === value);
}

export function isMintGameTemplate(template) {
  return TEMPLATES_GAME.find((item) => item === template?.value);
}

export function isMintGameType(type) {
  return !!TYPE_LESSON_MINT_GAME.find((item) => item === type);
}

export function isVanillaType(type) {
  return !!TYPE_LESSON_VANILLA.find((item) => item === type);
}

export function isEdelvives(organization) {
  return organization?.tenant?.guid === 'EDELVIVES_DIGITAL_PLUS';
}

export function isGotIt(organization) {
  return organization?.tenant?.guid === 'GOTITBYME';
}

export function isRichTextTemplate(template) {
  const { value } = template;
  return value !== undefined && value !== TEMPLATE_VANILLA && !isUnoiTemplate(template) && !isKidTemplate(template);
}

export function isComponent(template) {
  return template?.value === TEMPLATE_COMPONENTS || template?.value === TEMPLATE_COMPONENTS_PDFS;
}

export function isComponentPDFs(template) {
  return template?.value === TEMPLATE_COMPONENTS_PDFS;
}

export function isSteam(template) {
  return template?.value === TEMPLATE_STEAM;
}

export function isPrimaryFixedTemplate(template) {
  return template?.value === TEMPLATE_PRIMARY_FIXED;
}

export function isPrimaryHybridTemplate(template) {
  return template?.value === TEMPLATE_PRIMARY_HYBRID;
}

export function isPrimaryFixedOrHybridTemplate(template) {
  return isPrimaryFixedTemplate(template) || isPrimaryHybridTemplate(template);
}

// Acepta ambas formas de template: la del formulario saneada (`value`) y la cruda de la API
// (`template_type`, p. ej. la fila del listado en la previsualización de programa).
export function isToolboxStandaloneTemplate(template) {
  return template?.value === TEMPLATE_TOOLBOX_STANDALONE || template?.template_type === TEMPLATE_TOOLBOX_STANDALONE;
}

export function isFixedLayoutFamilyTemplate(template) {
  return isPrimaryFixedOrHybridTemplate(template) || isToolboxStandaloneTemplate(template);
}

// Power Lesson es un switch del programa, pero las plantillas de maqueta fija e híbrida
// lo usan siempre, así que también cuentan.
export function isPowerLessonProgram(program) {
  return !!program?.has_power_lesson || isPrimaryFixedOrHybridTemplate(program?.template);
}

// Determina si se debe mostrar el selector de sección en los diálogos de contenido.
export function shouldShowSectionSelector(program) {
  return isPowerLessonProgram(program);
}

export function shouldShowEvaluationPeriodForPrimaryHybrid(template, setting) {
  return isPrimaryFixedOrHybridTemplate(template);
}

export function shouldShowAdvancedLook(template) {
  return isFixedLayoutFamilyTemplate(template) || isComponentPDFs(template);
}

export function canUnitCopy(template) {
  return template?.value !== TEMPLATE_COMPONENTS;
}

export function canLessonCopy(template) {
  return template?.value !== TEMPLATE_COMPONENTS && template?.value !== TEMPLATE_STEAM;
}

export function canLessonMove(template) {
  return template?.value !== TEMPLATE_COMPONENTS;
}

export function canCreateMoreTheOneUnit(template) {
  return isComponent(template);
}

export function canUploadImageUnit(template) {
  return !isComponent(template);
}
